import {useSelector} from "react-redux";
import {RootState} from "../../../redux/store";
import {CustomerDashboardMenuData, DashboardMenuData} from "../../../services/menu-data";
import {NavLink} from "../nav-link/nav-link";
import {StyledLinksGroup} from "./nav-links-group.style";

const NavLinksGroup = () => {
  const {userInfo} = useSelector((state: RootState) => state.userLogin);
  const {activeContext} = useSelector((state: RootState) => state.userContext);

  const currentUserContext =
    activeContext || (userInfo?.isCustomer ? "customer" : "coach");

  const menuData =
    currentUserContext === "customer" ? CustomerDashboardMenuData : DashboardMenuData;

  return (
    <StyledLinksGroup>
      {menuData.map((menuItem, idx) => (
        <div className="nav-category" key={idx}>
          {menuItem?.title && <p className="nav-category-title">{menuItem?.title}</p>}
          {menuItem.navLink.map((link, idx) => (
            <NavLink
              key={idx}
              to={link.to}
              label={link.label}
              icon={link.icon}
              isComingSoon={link.isComingSoon}
              isBtnLink={link.isBtnLink}
              children={link.children}
            />
          ))}
        </div>
      ))}
    </StyledLinksGroup>
  );
};

export {NavLinksGroup};
